import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var TabChild = styled.div.withConfig({
  displayName: "TabChild",
  componentId: "sc-e313xw-0"
})(["display:", ";", ""], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? 'block' : 'none';
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === 'columns' && css(["float:left;width:50%;height:100%;padding-right:30px;", ""], maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      float: none;\n      width: 100%;\n      padding-right: 0;\n      margin-top: 30px;\n    "]))));
});